<template>
  <pagerlist
    :tableHeader="this.testpositionlogic.listHeader()"
    :tableData="testPositionList"
    :page="this.testpositionlogic.searchForm.page"
  />
  <pager
    :page="this.testpositionlogic.searchForm.page"
    :numTotal="numTotal"
    :handleCurrentChange="handleCurrentChange"
  />
</template>

<script>
import pagerlist from "@/components/listComponents/pagerList";
import pager from "@/components/listComponents/pager";
export default {
  components: {
    pagerlist,
    pager,
  },
  data() {
    return {
      numTotal: 0,
      testPositionList: [],
    };
  },
  mounted() {
    this.handleCurrentChange();
  },
  methods: {
    handleCurrentChange: function (page = 1) {
      this.testpositionlogic.getTestPositionList().then((res) => {
        this.testPositionList = res.testPositionList;
        this.numTotal = res.total;
      });
    },
  },
};
</script>




